import { Controller } from "@hotwired/stimulus";

// Persists the "This is a public computer" checkbox on the sign-in page.
// Toggling it POSTs to the server immediately (no sign-in required): checking
// clears any remembered sign-in cookies, and the checkbox's own checked state
// is kept in a long-lived cookie until unchecked. The page reloads so the
// remembered sign-in box appears/disappears right away.
export default class extends Controller {
  static values = { url: String };

  async toggle(event) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({ public_computer: event.target.checked ? "1" : "0" }),
    });
    window.location.reload();
  }
}
